import { Injectable,Renderer2,RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ThemeserviceService {

  private renderer:Renderer2

  constructor(private Renderer:RendererFactory2) {
    this.renderer=Renderer.createRenderer(null,null)
   }

   applyTheme(role:string):void{
    const body =document.body;
    const themeClass =`theme-${role}`

    body.classList.forEach((classname)=>{
      if(classname.startsWith('theme-')){
        this.renderer.removeClass(body,classname)
      }
    })
    this.renderer.addClass(body,themeClass)

   }
}
